import { MutableRefObject, useEffect, useRef } from 'react';

export function usePrevious<T>(current: T): MutableRefObject<T> {
    const storedValue = useRef(current);

    useEffect(() => {
        storedValue.current = current;
    });

    return storedValue;
}
